/// <amd-module name="typeahead/core/google/GoogleMapsSuggestion"/>

import {IGoogleMapsSuggestionResult} from "typeahead/core/google/GoogleMapsDataProvider";
import {Suggestion} from "typeahead/core/Suggestion";
import {Optional} from "typeahead/core/util/Optional";

export class GoogleMapsSuggestion extends Suggestion {
    protected data: IGoogleMapsSuggestionResult;

    public getSourceName(): Optional<string> {
        return Optional.of(this.data.sourceName);
    }

    public getSourceId(): Optional<string> {
        return Optional.of(this.data.sourceId);
    }

    public shouldTriggerDomElementChangeOnSelection(): boolean {
        return true;
    }

    public isAddrAutoComplete(): boolean {
        return true;
    }
}
